<ng-container *ngIf="showGiftCardRedeem">
  <h3>{{ 'Giftcard / Discount' | translate }}</h3>
  <p>{{ 'Please enter your Giftcard or Discount code here' | translate }}:</p>
  <div class="container">
    <div class="row">
      <div class="col-md-7 text-center p-0">
        <!-- <p *ngIf='error' class="tooltiptext tooltip-top tooltip-error" style="opacity: 1; visibility:visible">
            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
            <br>
            <span>{{ error | translate }}</span>
          </p> -->

        <app-input class="card-number" [title]="'Your code' | translate" [name]="'cardNumber'" [(ngModel)]="cardNumber">
        </app-input>
      </div>
      <div class="col-md-5 text-center p-0">
        <app-button [title]="'Redeem' | translate" (click)="redeem(cardNumber)"
          [buttonCssClass]="'button button-right button-black float-right'"></app-button>
      </div>
    </div>
  </div>
</ng-container>
<div class="row" *ngIf="redeemedGiftCards.length !== 0 || discountCoupons.length !== 0">
  <div class="col redeemed-discount">
    <p>{{ redeemGiftMessage | translate }}</p>
    <hr class="mw-100">
    <div class="redeemed-box" *ngFor="let redeemedGiftCard of redeemedGiftCards">
      <div class="basket-delete-article" (click)="deleteRedeemedGiftCard(redeemedGiftCard)">
        <div class="svg-container" [inlineSVG]="'assets/svg/icon/trash-solid.svg'"></div>
      </div>
      {{ getGiftCardName(redeemedGiftCard.cardNumber) | translate }}
      <span class="amount"> {{ toMoneyStr(redeemedGiftCard.amount) }} </span>
    </div>
    <div class="redeemed-box" *ngFor="let discountCoupon of discountCoupons">
      <div class="basket-delete-article" (click)="deleteDiscountCoupon(discountCoupon)">
        <div class="svg-container" [inlineSVG]="'assets/svg/icon/trash-solid.svg'"></div>
      </div>
      {{ discountCoupon.name }}
      <span class="amount"> {{ toMoneyStr(discountCoupon.amount) }} </span>
    </div>
    <hr class="mw-100">
  </div>
</div>
